<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Report Cash Flow Date Range
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="process()">
                    <i class="fa fa-play"></i>
                    Process
                </button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row >
                <b-col lg="8">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">Line Layout</span></b-input-group-prepend>
                        <b-form-select v-model="filter.layout" :plain="true" :options="layouts" :state="!$v.filter.layout.$error"></b-form-select>
                        <b-input-group-prepend><span class="p-2">Trx. Date</span></b-input-group-prepend>
                        <b-form-input v-model="filter.tgl1" :state="!$v.filter.tgl1.$error"  type="date" placeholder="from date" ></b-form-input>
                        <b-form-input v-model="filter.tgl2" :state="!$v.filter.tgl2.$error"  type="date" placeholder="until date" class="ml-1"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >
            <b-card no-body>
                <div class="report-wraper">
                    <table style="width: 100%;">
                        <thead>
                            <tr>
                            <th width="110px">Src.Code</th>
                            <th >Description</th>
                            <th style="text-align:right" ><span v-if="(filter.tglprev)"> As of {{filter.tglprev | moment("DDMMM")}} </span></th>
                            <th style="text-align:right" width="110px">%</th>
                            <th style="text-align:right" ><span v-if="(filter.tgl1)"> ({{filter.tgl1 | moment("DDMMM")}} - {{filter.tgl2 | moment("DDMMM")}}) </span></th>
                            <th style="text-align:right" width="110px">%</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in rptLines" :key="row.idrowunik">
                            <td :class="row.kelas">{{row.kode}}</td>
                            <td :class="row.kelas"><span v-html="row.uraianhtm"></span></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.prevmonth | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.persen_prev | numFormat}}</td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">
                                <b-link v-if="row.kode" @click="drillCurrentMonth(row)">{{row.monthtt | numFormat}}</b-link>      
                                <span v-if="!(row.kode)">{{row.monthtt | numFormat}}</span>                          
                            </td>
                            <td v-else ></td>
                            <td :class="row.kelas" v-if="row.kode || row.rumus"  style="text-align:right">{{row.persen_mon | numFormat}}</td>
                            <td v-else ></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import cashflow from "../../apis/cashflow";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
        layout: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      filter: {tabIndex:1},
      isLoading: false,
      layouts:[],
      horizontal: true,
      reportUrl: null,
      showReport:false,
      rptLines:[]
    };
  },
components: { Loading },  
computed:{
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    },
    layout() {
        return this.filter.layout;
    }
  },
watch:{
    layout: async function(newval) {
        //   this.rptLines= await cashflow.layoutcashflow({layout : newval});
        const lines = await cashflow.layoutcashflow({layout : newval});
        const hasil = lines.reduce((newArr, line) => {
            if (line.item_hapus !== 1) newArr.push(line);
            return newArr;
        }, []);          
          this.rptLines=hasil;
      }
  },
created: async function (){
     this.layouts = await cashflow.layoutcashflow_combo();
    var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    var tgl1 = moment(tgl2.format('YYYY') + '-01-01', 'YYYY-MM-DD');
    this.filter.tgl1=tgl1.format('YYYY-MM-DD');
    this.filter.tgl2=tgl2.format('YYYY-MM-DD');
    this.filter.tglprev= tgl1.subtract(1, 'day');
    // this.filter.tglbulanlalu= moment(this.filter.tgl2, 'YYYY-MM-DD').add(1, 'D').add(-1, 'M');
        this.filter.tglbulanlalu=  moment(`${tgl2.format('YYYY-MM')}-01`,'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    this.filter.tglbulanini= tgl2;
  },
methods:{
    // updateTgl1: function() {
    //     var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
    //     if (!this.filter.tgl1){
    //         this.filter.tgl1=`${tgl2.format('YYYY-MM')}-01`;
    //         this.tahun=tgl2.format('YYYY');
    //         this.$forceUpdate();
    //     } else {
    //         var tgl1 = moment(this.filter.tgl1, 'YYYY-MM-DD');
    //         if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
    //             this.filter.tgl1=`${tgl2.format('YYYY')}-01-01`;
    //             this.tahun=tgl2.format('YYYY');
    //             this.$forceUpdate();
    //         }
    //     }
    // },
    // updateTgl2: function() {
    //     setTimeout(() => {
    //         var tgl1 = moment(this.filter.tgl1, 'YYYY-MM-DD');
    //         if (!this.filter.tgl2){
    //             this.filter.tgl2=`${tgl1.format('YYYY')}-12-31`;
    //             this.tahun=tgl1.format('YYYY');
    //             this.$forceUpdate();
    //         } else {
    //             var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
    //             if (tgl1.format('YYYY') != tgl2.format('YYYY')){
    //                 this.filter.tgl2=`${tgl1.format('YYYY')}-12-31`;
    //                 this.tahun=tgl1.format('YYYY');
    //                 this.$forceUpdate();
    //             }
    //         }            
    //     }, 500);
    // },
    process: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            var thn1 = moment(this.filter.tgl1).format('YYYY');
            var thn2 = moment(this.filter.tgl2).format('YYYY');
            if (thn1 !== thn2){
                toastr.error('Date Range is not valid','ERROR MESSAGE',10000);
                this.filter.tgl1=`${moment(this.filter.tgl2).format('YYYY')}-01-01`;
                this.$forceUpdate();
            }

            const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
            model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
            model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
            const thnAwal=moment(this.filter.tgl1).format('YYYY');
            const thnAkhir= moment(this.filter.tgl2).format('YYYY');
            if ((thnAwal !== thnAkhir) || (model.tgl1 >= model.tgl2)) {
                toastr.error('Date range is invalid');
                return;
            }                            

            this.isLoading=true;
            try {
                this.filter.tglprev=moment(this.filter.tgl1).subtract(1, "days");
                this.rptLines= await cashflow.cashflow_date(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.showReport=true;
                const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
                model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
                this.reportUrl= await cashflow.cashflow_dateprint(model);
                this.isLoading=false;
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            const model = {};
                for (var key in this.filter) {
                    model[key] = this.filter[key];
                }
            model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
            model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');
            const thnAwal=moment(this.filter.tgl1).format('YYYY');
            const thnAkhir= moment(this.filter.tgl2).format('YYYY');
            if ((thnAwal !== thnAkhir) || (model.tgl1 >= model.tgl2)) {
                toastr.error('Date range is invalid');
                return;
            }                            
            this.isLoading=true;
            try {
                const response = await cashflow.cashflow_dateexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    drillCurrentMonth: function(data)
    {
        if (data.kode) {
            const model= {};
            model.tgl1= moment(this.filter.tgl1).format('YYYY-MM-DD');
            model.tgl2= moment(this.filter.tgl2).format('YYYY-MM-DD');

            let routeData = router.resolve({path: `general-ledger/${data.kode}/${model.tgl1}/${model.tgl2}`});
            window.open(routeData.href, '_blank');
        }
    },
    drillMonToDate: function(data)
    {
        if (data.kode) {
            var tgl2 = moment(this.filter.tgl2, 'YYYY-MM-DD');
            // router.push({name :'accounting.gl', params: { kodeaw: data.kode, kodeak: data.kode, tgl1:`${tgl2.format('YYYY-MM')}-01`, tgl2: this.filter.tgl2}});
            let routeData = router.resolve({path: `general-ledger/${data.kode}/${tgl2.format('YYYY')}-01-01/${tgl2.format('YYYY-MM-DD')}`});
            window.open(routeData.href, '_blank');
        }
    },
    close(){
      router.push("home");
    }
  }
};
</script>
